module.exports = __webpack_public_path__ + "cb554867aec0a0b91e32895c4f00c192.png";